import {BaseModel} from "./base.model";
import {ShipmentType} from "../interfaces/shipment-type.interface";
import {TransportService} from "./transport-service.model";
import {Provider} from "./provider.model";
import {Currency} from "./currency.model";
import {GoodsPackage} from "../interfaces/goods-package.interface";
import {DataEntity} from "./data-entity.model";
import {Package} from "../interfaces/package.interface";
import {Deserializable} from "../interfaces/deserializable.interface";

export class Job extends BaseModel implements Deserializable {

  createdById: string;
  createdDate: Date;
  type: ShipmentType;
  status: any;
  invoiceStatus: any;
  documentStatus: any;
  paymentStatus: any;
  service: TransportService;
  reference: string;
  provider: Provider;
  towed: boolean;
  tracked: boolean;
  loading: boolean;
  currency: Currency;
  price: number;
  openDate: Date;
  closingDate: Date;
  sailingDate: Date;
  etaDate: Date;
  vesselName: string;
  lineReference: string;
  containerNumber: string;
  sealNumber: string;
  vehicleContainerName: string;
  goodsPackage: GoodsPackage;
  collectionDate: Date;
  expectedDeliveryToPortDate: Date;
  deliveryDate: Date;
  loadDate: Date;
  restituteFromDate: Date;
  restituteToDate: Date;
  invoiceDate: Date;

  collectionNotes: string;
  loadingNotes: string;
  restitutionNotes: string;
  deliveryNotes: string;
  invoiceNotes: any[];

  specialInstructions: any;

  client: DataEntity;
  exporter: DataEntity;
  consignee: DataEntity;
  agent: DataEntity;
  carrier: DataEntity;
  collection: DataEntity;
  delivery: DataEntity;
  notify: DataEntity;
  portAddress: DataEntity;
  loadingAddress: DataEntity;
  transportCompany: DataEntity;
  restitution: DataEntity;

  packages: Package[];

  isQuotation: boolean;

  incoterm: any;
  reportHistory: any[];

  mrm: string;

  editable: boolean;

  constructor() {
    super();

    this.goodsPackage = {
      description: '',
      value: null,
      length: null,
      width: null,
      height: null,
      grossWeight: null,
      chargeWeight: null,
      makeModel: '',
      registration: '',
      chassisNumber: '',
      engineNumber: '',
      colour: '',
      yearOfManufacture: '',
      cbm: ''
    }
  }

  deserialize(input: any): this {
    Object.assign(this, input);

    if (input.service) {
      this.service = new TransportService().deserialize(input.service);
    }

    if (input.client) {
      this.client = new DataEntity().deserialize(input.client);
    } else {
      this.client = new DataEntity();
    }

    if (input.exporter) {
      this.exporter = new DataEntity().deserialize(input.exporter);
    } else {
      this.exporter = new DataEntity();
    }

    if (input.consignee) {
      this.consignee = new DataEntity().deserialize(input.consignee);
    } else {
      this.consignee = new DataEntity();
    }

    if (input.carrier) {
      this.carrier = new DataEntity().deserialize(input.carrier);
    } else {
      this.carrier = new DataEntity();
    }

    if (input.delivery) {
      this.delivery = new DataEntity().deserialize(input.delivery);
    } else {
      this.delivery = new DataEntity();
    }

    if (input.notify) {
      this.notify = new DataEntity().deserialize(input.notify);
    } else {
      this.notify = new DataEntity();
    }

    if (input.portAddress) {
      this.portAddress = new DataEntity().deserialize(input.portAddress);
    } else {
      this.portAddress = new DataEntity();
    }

    if (input.loadingAddress) {
      this.loadingAddress = new DataEntity().deserialize(input.loadingAddress);
    } else {
      this.loadingAddress = new DataEntity();
    }

    if (input.transportCompany) {
      this.transportCompany = new DataEntity().deserialize(input.transportCompany);
    } else {
      this.transportCompany = new DataEntity();
    }

    if (input.restitution) {
      this.restitution = new DataEntity().deserialize(input.restitution);
    } else {
      this.restitution = new DataEntity();
    }

    if (input.collection) {
      this.collection = new DataEntity().deserialize(input.collection);
    } else {
      this.collection = new DataEntity();
    }




    return this;
  }
}
